import styled from 'styled-components';

const MyDiv = styled.div`
  .card {
    background: white;
    border-radius: 16px;
    padding: 16px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
    height: 180px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .title-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }


  .subtext {
    font-size: 12px;
    color: gray;
    margin-top: 4px;
  }

  .input-row {
    display: flex;
    gap: 10px;
    margin-top: 10px;
  }

  .action-btn {
    width: 100%;
    background-color: #006838;
    color: white;
    border-radius: 20px;
    padding: 6px;
    font-size: 12px;
    font-weight:400px;
    font-family: "Poppins", sans-serif!important;
    margin-top: auto;
    &:hover{
    background-color: #006838;
    color: white;
    
    }
  }

  .disabled-btn {
    background-color: #888;
    cursor: no-drop;
    &:hover{
      background-color: #888;
      cursor: no-drop;
    }
  }

  .content {
    flex-grow: 1;
  }
`;

export default MyDiv;
